import { useMemo } from 'react';
import useCachedValue from '../useCachedValue';

export interface IUseFilterButtonFilters {
  [key: string]: any;
}

export type TUseFilterButtonOmitFilters = string[];

export interface IUseFilterButtonReturn {
  isFilterActive: boolean;
  numberOfActiveFilters: number;
}

const useFilterButton = (
  filters: IUseFilterButtonFilters,
  omitFilters: TUseFilterButtonOmitFilters = [],
): IUseFilterButtonReturn => {
  const cachedFilters = useCachedValue<IUseFilterButtonFilters>(filters);
  const cachedOmitFilters = useCachedValue<TUseFilterButtonOmitFilters>(omitFilters);

  const { isFilterActive, numberOfActiveFilters } = useMemo(() => {
    let processedNumberOfActiveFilters = 0;
    const isOmitFiltersAsArray = Array.isArray(cachedOmitFilters);
    const filterValuesAsEntries = Object.entries(cachedFilters);
    filterValuesAsEntries.forEach(([key, value]) => {
      if (isOmitFiltersAsArray && cachedOmitFilters.includes(key)) {
        return;
      }
      if (value === undefined || value === null) {
        return;
      }
      processedNumberOfActiveFilters += 1;
    });
    return {
      isFilterActive: !!processedNumberOfActiveFilters,
      numberOfActiveFilters: processedNumberOfActiveFilters,
    };
  }, [cachedFilters, cachedOmitFilters]);

  return { isFilterActive, numberOfActiveFilters };
};

export default useFilterButton;
